import React from "react";
import "./MetaTable.css";

const MetaTable = (props) => {

  return (
    <table className="MetaTable">
      <tbody>
        {props.children}
      </tbody>
    </table>
  )

}

export default MetaTable;